import React, { useContext } from "react";
import { GlobalStateContext } from "./App";

//{fPosgrado, setItem, DataNivel, DataCamp, DataFac}
const FiltroPrograma = () => {
  const {
    idCampus,
    setidCampus,
    idNivel,
    setidNivel,
    idFacultad,
    setidFacultad,
    optionProgram,
    optionFacultad,
    optionCampus,
    setRefreshKey
  } = useContext(GlobalStateContext);

 const handleChangeCampus = (e) => {
    const value = e.target.value;
    if (value === idCampus) {
      setRefreshKey((prev) => prev + 1);
      setidCampus(value);
    }else {
      setidCampus(value);;
    }

   // setidCampus(value);
  };

  const handleChangeNivel = (e) => {
    const value = e.target.value;

    if (value === idNivel) {
      setRefreshKey((prev) => prev + 1); 
    } else {
      setidNivel(value);;
    }
   // setidNivel(value);
 
  };

  const handleChangeFacultad = (e) => {
    const value = e.target.value;
    if (value === idFacultad) {
      setRefreshKey((prev) => prev + 1);
    } else {
      setidFacultad(value);
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <form className="contact-form form-group" >
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
              <div>
                <label>Campus de Interés: </label>
              </div>

              <select className="select" value={idCampus} onChange={ handleChangeCampus}>
                <option value="all">Todos los campus</option>
                {optionCampus.map((val, index) => (
                  <option value={val.id} key={index}>
                    {val.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
              <div>
                <label>Nivel de Interés: </label>
              </div>

              <select className="select" value={idNivel} disabled={optionProgram.length === 0} onChange={handleChangeNivel}>
                <option value="all">Todos los niveles</option>
                {optionProgram.map((val, index) => (
                  <option value={val.id_nivel} key={index}>
                    {val.nivel}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-xs-12 col-sm-12 col-md-4 col-lg-4 ">
              <div>
                <label>Área Académica: </label>
              </div>

              <select className="select" value={idFacultad} disabled={optionFacultad.length === 0} onChange={handleChangeFacultad}>
                <option value="all">Todas las facultades</option>
                {optionFacultad.map((val, index) => (
                  <option value={val.id_facultad} key={index}>
                    {val.facultad}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </div>

      </div>

    </>

  );
};

export default FiltroPrograma;